import Layout from "../layout/Layout";
import { EntityNames } from "../../../enums/EntityNames";
import EntityView from "../layout/EntityView/EntityView";

export default function DocumentationPage() {

    return (
        <Layout pageTitle="Documentation" showBackButton={false} showBreadcrumb={false} canScroll={false}>
            <EntityView entityName={EntityNames.fileUploads} entityId={undefined} />
        </Layout>
    )
}


